import type { FC } from 'react';
import { memo, useCallback } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { usePerformanceAction } from '../usePerformanceAction.tsx';
import type { Props } from '../types/PageSegmentLoadMarkProps.ts';

const noop = () => {};

/**
 * UFO equivalent of Bm3PageSegmentLoadMark.
 *
 * Records a UFO custom mark via `addUFOCustomMark` at the configured timing.
 */
const UFOSegmentLoadMarkComponent: FC<Props> = memo((props) => {
	const { markName, timing, onComplete = noop, timestamp } = props;
	// The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
	// is provided, so resolvedKey is always a defined string at runtime.
	const resolvedKey: string = props.metricKey ?? props.metric.key;
	const handleMark = useCallback(() => {
		addUFOCustomMark(markName, timestamp);
		onComplete();
		// Not adding exhaustive dependencies because we want this to fire only once,
		// despite any changes to `timestamp`
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resolvedKey, onComplete]);

	usePerformanceAction(handleMark, timing);
	return null;
});

export { UFOSegmentLoadMarkComponent as UFOSegmentLoadMark };
